module.exports = __webpack_public_path__ + "static/media/hajj-package-4.184cefaf.jpg";